import {h} from "preact";
import {GlobalsContext} from "../AppContext";
import {useContext} from "preact/hooks";
import style from './offer-container.css';
import clsx from "clsx";
import CloseButton from "./CloseButton";

interface OwnProps{
    text: string;
}

const OfferContainer = ({ text }: OwnProps) => {
    const { widgetOpen } = useContext(GlobalsContext);
    return (
        <div className={clsx(style.root,widgetOpen ? style.open : style.minimized) }>
        <div dangerouslySetInnerHTML ={{
            __html: text
        }}/>
            <CloseButton/>
        </div>
    );
};

export default OfferContainer;
